import React from 'react';

const AlarmFeatureView = ({ name, picUrlDesktop, picUrlMobile, selected }) => {
  const cssName = selected ? 'AlarmFeatureView selected' : 'AlarmFeatureView';
  return (
    <div className={cssName}>
      <img
        className="picture desktop"
        src={`${process.env.NEXT_PUBLIC_CDN}${picUrlDesktop}`}
        alt="alarmas para chalets"
        loading="lazy"
      />
      <img
        className="picture mobile"
        src={`${process.env.NEXT_PUBLIC_CDN}${picUrlMobile}`}
        alt="alarmas para chalets"
        loading="lazy"
      />
      <style jsx>
        {`
          .AlarmFeatureView {
            img {
            }
            .picture {
              width: 100%;
              &.mobile {
                display: none;
              }
              &.desktop {
                display: block;
              }
            }
          }
          @media screen and (max-width: 768px) {
            .AlarmFeatureView {
              padding: 1rem;
              .picture {
                width: 90%;
                margin: auto;
                &.mobile {
                  display: block;
                }
                &.desktop {
                  display: none;
                }
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default AlarmFeatureView;
